import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("aFzkz"), parcelRequire.load("6qO4J"), parcelRequire.load("fHoW9"), parcelRequire.load("euokj"), parcelRequire.load("3shle"), parcelRequire.load("hwI0u"), parcelRequire.load("j7ts3"), parcelRequire.load("lfEzl")]).then(() => {
  return Promise.all([waitForCSS("/Accordion.faaa34b9.css")]);
}).then(() => {
let originalModule = parcelRequire("fxMzH");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("aFzkz")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6qO4J")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("fHoW9")} />
  <link rel="modulepreload" href={parcelRequire.resolve("euokj")} />
  <link rel="modulepreload" href={parcelRequire.resolve("3shle")} />
  <link rel="modulepreload" href={parcelRequire.resolve("hwI0u")} />
  <link rel="modulepreload" href={parcelRequire.resolve("j7ts3")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lfEzl")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
